import React, { useContext, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import moment from "moment";
import DataTableBase from "../../../common/Datatable";
import TrainerContext from "../../../../../context/trainerContext/TrainerContext";
import makeRequest from "../../../../../api";
import { getUserSessionsList } from "../../../../../api/services/slot-management";
import { userService } from "../../../../../api/services";

const categoryList = ["ALL", "NUTRITION", "HABIT", "BUDDY"];
const pollTime = 1000 * 60 * 5; // 5 min

const UserSessionsListing = () => {
  const params = useParams();

  const { getTrainerState } = useContext(TrainerContext);
  const trainerData = getTrainerState();

  const [sessionsList, setSessionsList] = useState<any>([]);
  const [filteredSessionsList, setFilteredSessionsList] = useState<any>([]);
  const [categoryFilter, setCategoryFilter] = useState("ALL");
  const [userDetails, setUserDetails] = useState<any>(null);

  const userId = params.userId;
  const trainerId = trainerData?.trainerId;

  useEffect(() => {
    let interval: any;
    const visibilityChangeEventListener = () => {
      if (document.visibilityState === "visible") {
        getSessionsList();
        interval = setInterval(() => {
          getSessionsList();
        }, pollTime);
      } else {
        if (interval) {
          clearInterval(interval);
        }
      }
    };
    visibilityChangeEventListener();
    document.addEventListener(
      "visibilitychange",
      visibilityChangeEventListener
    );
    return () => {
      document.removeEventListener(
        "visibilitychange",
        visibilityChangeEventListener
      );
      if (interval) {
        clearInterval(interval);
      }
    };
  }, []);

  useEffect(() => {
    let filteredList = sessionsList;
    if (categoryFilter !== "ALL") {
      filteredList = filteredList?.filter(
        (item: any) => item.trainerCategory === categoryFilter
      );
    }

    setFilteredSessionsList([...filteredList]);
  }, [sessionsList, categoryFilter]);

  useEffect(() => {
    const getUserData = async () => {
      const res = await makeRequest(userService.getUserDetails(userId));
      setUserDetails({ ...res?.data?.userDto });
    };
    if (userId) {
      getUserData();
    }
  }, [userId]);

  const getSessionsList = async () => {
    try {
      const response = await makeRequest(
        getUserSessionsList({
          trainerId,
          userId,
        })
      );
      if (response?.status === 200) {
        const res = response?.data?.body?.sort(
          (a: any, b: any) => +a?.startTime - +b?.startTime
        );

        setSessionsList([...res]);
      }
    } catch (error: any) {
      toast.error(`${error?.response?.data?.message}`);
    }
  };

  const handleCategoryButtonClick = (e: any) => {
    const category = e.target.getAttribute("data-category");
    setCategoryFilter(category);
  };

  const columns = [
    {
      name: "Coach name",
      selector: (row: any) => row.trainerName,
      cell: (row: any) => {
        return <div className="">{row?.trainerName}</div>;
      },
      width: "20%",
    },
    {
      name: "Date",
      selector: (row: any) => row?.startTime,
      cell: (row: any) => {
        return <div>{moment(row?.startTime * 1000).format("DD MMM YY")}</div>;
      },
      width: "30%",
    },
    {
      name: "Time",
      selector: (row: any) => row?.startTime,
      cell: (row: any) => {
        return (
          <div>
            {moment(row?.startTime * 1000).format("hh:mm A")} -{" "}
            {moment(row?.endTime * 1000).format("hh:mm A")}
          </div>
        );
      },
      width: "30%",
    },
    {
      name: "Time",
      selector: (row: any) => row?.status,
      cell: (row: any) => {
        return (
          <div
            className={`text-capitalize ${
              row?.status === "MISSED" || row?.status === "CANCELLED"
                ? "text-danger"
                : row?.status === "RESCHEDULED"
                ? "text-secondary"
                : "text-success"
            }`}
          >
            {row?.status?.toLowerCase()}
          </div>
        );
      },
      width: "20%",
    },
  ];

  return (
    <div className="container-lg">
      <div className="mb-4">
        {userDetails?.fullName && (
          <h6 className="fw-700 fs-24 mb-2">
            {userDetails?.fullName}'s Sessions
          </h6>
        )}
        <div className="d-flex align-items-center justify-content-start">
          {categoryList?.map((item: string, index: number) => (
            <button
              key={`category-button-${index}`}
              className={`btn btn-sm rounded-pill me-3 px-4 text-capitalize ${
                item === categoryFilter
                  ? "btn-outline-success fw-600"
                  : "btn-outline-secondary"
              }`}
              data-category={item}
              onClick={handleCategoryButtonClick}
            >
              {item.toLowerCase()}
            </button>
          ))}
        </div>
      </div>
      {filteredSessionsList?.length === 0 ? (
        <h6 className="mb-0">No sessions for this user.</h6>
      ) : (
        <DataTableBase
          columns={columns}
          data={filteredSessionsList}
          pagination={false}
        />
      )}
    </div>
  );
};

export default UserSessionsListing;
